import { TagBar } from '../../TagBar'

import { getSelectTagLabel } from './SelectValueTags.utils'

function SelectValueTags({ getText = getSelectTagLabel, value, ...restProps }) {
  return value?.length > 0 ? (
    <TagBar {...restProps} getText={getText} items={value} />
  ) : null
}

export default SelectValueTags
